<template>
  <el-upload
    v-bind="$attrs"
    class="f360-upload-drag-drop"
    :class="{ 'f360-upload-drag-drop--error': error }"
  >
    <MaterialIcon
      icon="drive_folder_upload"
      class="f360-upload-drag-drop__icon"
    />
    <div class="f360-upload-drag-drop__text">
      <template v-if="$slots.label"></template>
      <template v-else>
        <b>Clique aqui</b> ou arraste-o para fazer o upload
      </template>
      <slot name="label" />
    </div>
  </el-upload>
</template>
<script setup lang="ts">
defineProps<{
  error?: boolean;
  width?: string;
}>();
</script>

<style lang="scss">
@mixin select-error {
  box-shadow: 0 0 0 1px #ed1517 inset !important;
  background-color: #fff1f1;
}

.f360-upload-drag-drop {
  min-height: 126px;
  width: 100%;
  box-sizing: border-box;

  &__text {
    font-size: 10px;
    line-height: 16px;
    margin-top: 4px;
  }

  &__icon {
    font-size: 32px;
  }

  .financas-upload-list {
    max-height: 8rem;
    overflow: scroll;
    // min-height: 10rem;
  }

  .financas-upload-dragger {
    border-radius: 5px;
    background-color: #e7e7e7;
    padding: 10px;

    &:hover {
      transition: all 0.4s;
      background-color: #edf7ff;
    }
  }

  &--error {
    .financas-upload-dragger {
      @include select-error;
    }
  }
}
</style>
